import AntdModal from 'antd/lib/modal'
import { MutableRefObject } from 'react'
import styled, { createGlobalStyle } from 'styled-components'

import { color } from '../styles'
import { SPACING } from '../styles/mixins/constants'
import { text } from '../styles/mixins/text'

import { Button } from './Button'
import { Icon } from './Icon'
import { Spacer } from './Spacer'

type Props = {
    isVisible: boolean
    title?: string
    disableOutsideClick?: boolean
    hideOverlay?: boolean
    cancelLabel?: string
    confirmLabel?: string
    content: JSX.Element | string | string[]
    containerRef?: MutableRefObject<HTMLDivElement | null>
    disableCancel?: boolean
    disableConfirm?: boolean
    hideActions?: boolean
    widthPx?: number
    onClose?: () => void
    onCancel?: () => void
    onConfirm?: () => void
}

export const Modal = (props: Props): JSX.Element => {
    const {
        title,
        isVisible,
        content,
        disableOutsideClick,
        disableCancel,
        disableConfirm,
        hideOverlay,
        cancelLabel = 'Cancel',
        confirmLabel = 'Confirm',
        hideActions,
        containerRef,
        widthPx,
        onClose,
        onCancel,
        onConfirm,
    } = props
    let footer = []
    if (onCancel) {
        footer.push(
            <>
                <Button
                    label={cancelLabel}
                    type="primary"
                    size="medium"
                    onClick={onCancel}
                    disabled={!!disableCancel}
                />
                <Spacer size={2} />
            </>
        )
    }
    if (onConfirm) {
        footer.push(
            <Button
                label={confirmLabel}
                type="accent"
                size="medium"
                onClick={onConfirm}
                disabled={!!disableConfirm}
            />
        )
    }

    if (hideActions) footer = []
    return (
        <Container>
            <GlobalStyles />
            <AntdModal
                width={widthPx}
                title={title}
                visible={isVisible}
                onCancel={() => {
                    onClose?.()
                }}
                maskClosable={!disableOutsideClick}
                mask={!hideOverlay}
                footer={footer.length ? footer : null}
                getContainer={containerRef?.current || undefined}
                closeIcon={
                    <Icon
                        iconKey="Ex"
                        color="secondary"
                        activeColor="muted"
                        size={4}
                        onClick={() => onClose?.()}
                    />
                }
            >
                <Content>{content}</Content>
            </AntdModal>
        </Container>
    )
}

const GlobalStyles = createGlobalStyle`
  .ant-modal-content {
    background-color: ${color.background.control};
    ${text('paragraph')}
  }
  .ant-modal-footer {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    border-top: 1px solid ${color.border.primary};
  }
  .ant-modal-close-x {
    width: auto;
    height: auto;
    padding: ${SPACING[2]};
  }
  .ant-modal-mask {
    z-index: 1002;
  }
  .ant-modal-wrap {
    z-index: 1002;
  }
`

const Container = styled.div`
    z-index: 1001;
`

const Content = styled.div``

Modal.Container = Container
Modal.Content = Content
